import React from "react";
import Nav from "@/sections/Nav";
import Hero from "@/sections/Hero";
import ProblemBlock from "@/sections/ProblemBlock";
import BrandProof from "@/sections/BrandProof";
import UseCases from "@/sections/UseCases";
import SystemBlock from "@/sections/SystemBlock";
import Packages from "@/sections/Packages";
import CloseBlock from "@/sections/CloseBlock";
import Footer from "@/sections/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Nav />
      <main>
        <Hero />
        <ProblemBlock />
        <SystemBlock />
        <Packages />
        <BrandProof />
        <UseCases />
        <CloseBlock />
      </main>
      <Footer />
    </div>
  );
}
